import { mustBeAdmin } from "../util/auth";

const Payroll = () => import("../components/content/payroll/payroll");
const InitiatePayroll = () => import("../components/content/payroll/initiatePayroll");
const ProcessPayroll = () => import("../components/content/payroll/processPayroll");
const PayrollDetails = () => import("../components/content/payroll/payrollDetails");
const PayrollHistory = () => import("../components/content/payroll/payrollHistory");

export const payrollRoute = {
  path: "/payroll",
  component: Payroll,
  children: [
    {
      path: "",
      component: PayrollHistory
    },
    {
      path: "/payroll/regular/initiate",
      name: "regularPayrollInitiate",
      component: InitiatePayroll
    },
    {
      path: "/payroll/regular/process",
      name: "processPayroll",
      component: ProcessPayroll
    },
    {
      path: "/payroll/:id/transactions",
      name: "payrollDetails",
      component: PayrollDetails
    }
  ],
  beforeEnter: mustBeAdmin
};
